export default "__VITE_ASSET__BCvEvhTo__"